import { render } from "./HdCardText.vue?vue&type=template&id=596e1739"
import script from "./HdCardText.vue?vue&type=script&lang=js"
export * from "./HdCardText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__